import Details from '@/components/Details/Details';
import InfoLabel from '@/components/InfoLabel';
import Tip from '@/components/Tip/Tip';
import IEventType from '@/types/IEventType';
import IHost from '@/types/IHost';
import { FormControl, FormHelperText } from '@chakra-ui/form-control';
import { List, Text } from '@chakra-ui/layout';
import { Button, Input, InputGroup, InputRightAddon } from '@chakra-ui/react';
import { FcAssistant } from 'react-icons/fc';
import Collaborator from './components/Host';
import useSectionHosts from './useSectionHosts';

export interface ISectionGeneralProps {
	service: IEventType;
	onChange: (values: Partial<IEventType>) => void;
}

export default function SectionHosts(props: ISectionGeneralProps) {
	const { t, handleCollaboratorsSubmit, register, handleRemove, hosts, formState } = useSectionHosts(props);

	return (
		<Details image={<FcAssistant />} title={t('Collaborators')}>
			<Tip>
				{t(
					'Invite your colleagues to collaborate with this booking page. These people will be able to make changes and sync their own calendars.'
				)}
			</Tip>

			<form onSubmit={handleCollaboratorsSubmit}>
				<FormControl size="sm">
					<InfoLabel
						htmlFor="email"
						text={t('Invite a collaborator to this booking page')}
						help={t('Collaborators will see this booking page and can make changes as if they were the owners.')}
					/>
					<InputGroup>
						<Input id="email" {...register('email')} placeholder={t('Email')} />
						<InputRightAddon>
							<Button isLoading={formState.isSubmitting} type="submit" variant="unstyled">
								{t('Invite')}
							</Button>
						</InputRightAddon>
					</InputGroup>
					<FormHelperText>{t('The collaborator needs to have a TimeTime account!')}</FormHelperText>
				</FormControl>
			</form>

			<Text mt="4" fontWeight="500">
				{t('Collaborators')}
			</Text>
			<List mt="4" spacing={3}>
				{hosts.sort(_sortByRole).map((c, i) => (
					<Collaborator {...c} key={i} onRemove={handleRemove} />
				))}
			</List>
		</Details>
	);
}

function _sortByRole(a: IHost, b: IHost): -1 | 0 | 1 {
	if (a.role === b.role) {
		return 0;
	}
	if (a.role === 'OWNER' && b.role === 'COLLABORATOR') {
		return -1;
	}
	return 1;
}
